import { gql } from '@apollo/client'

export const BASIC_PRODUCT_FRAGMENT = gql`
  fragment BasicProduct on Product {
    id
    upcA
    name
    marketingImageUrl
  }
`
